export const isBrowserInternetExplorer = () => {
  const userAgent = navigator.userAgent
  const containsInternetExplorerKeywords = userAgent.search(/(MSIE|Trident)/)

  return containsInternetExplorerKeywords > -1
}
